export default "__VITE_ASSET__yVbj8Xmq__"